const {
    createApp,
    ref
} = Vue

createApp({
    data() {
        return {
            activeInput: null,
            isResultLoading: true,
            years: [],
            eventYear: new Date().getFullYear(),
            eventName: null,
            eventType: null,
            eventId: null,
            events: [],
            races: [],
            brackets: [],
            raceId: null,
            bracketId: null,
            autocompleteInitialized: false,
            display: null,
            leaderboardData: null,
            bibNo: null,
            bibType: null,
            bibData: null,
            photosStartIndex: 0,
            photosPerPage: 8,
            confettiInterval: null,
            participantFlag: true,
            comparedData: null,
            comparedBib: null,
            lastSearchedEvent: null,
            cachedEventsList: null,
            lastSearchedParticipant: null,
            cachedParticipantList: null,
            isMJVideoPlayed: false,
            eventPoweredByStatus: null,
            eventPoweredByLogo: null,
            suggestionForm_name: null,
            suggestionForm_email: null,
            suggestionForm_mobile: null,
            suggestionForm_service: null,
            suggestionForm_experience: null,
            suggestionForm_suggestion: null,
            suggestionFormErrors: {},
            suggestionFormLoading: false,
            isIpBlocked: false,
            photoFile: null,
            photoPreviewUrl: null,
            photoCropper: null,
            showPhotoCrop: false,
            showPhotoOutput: false,
            croppedPhotoFile: null,
            outputImageUrl: null,
            isPhotoSubmitting: false,
            isFlipping: false,
        }
    },
    computed: {
        currentPhotos() {
            return this.bibData.photos.data.results.slice(this.photosStartIndex, this.photosStartIndex +
                this
                    .photosPerPage);
        }
    },
    mounted() {
        window.addEventListener('popstate', this.handlePopState);
        this.initFingerprint();
    },
    setup() {
        const currentYear = new Date().getFullYear();
        const years = Array.from({
            length: currentYear - 2015
        }, (_, index) => currentYear - index);
        return {
            years,
            eventYear: currentYear
        };
    },
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        var urlSlug = urlParams.get('q');
        if (urlSlug) {
            const decodedSlug = atob(urlSlug);
            const urlData = JSON.parse(decodedSlug);
            this.eventName = urlData.e_name;
            this.eventId = urlData.e_id;
            this.bibNo = urlData.bibNo;
        }
        if (this.eventName && this.eventId && !this.bibNo) {
            this.fetchEventLeaderboard(this.eventId);
            this.fetchRaces(this.eventId);
        } else if (this.eventName && this.eventId && this.bibNo) {
            this.fetchRaces(this.eventId);
            this.fetchBibDetails(this.eventId, this.bibNo);
        }
    },
    methods: {
        setActiveInput(inputId) {
            this.activeInput = inputId;
        },
        isInputActive(inputId) {
            return this.activeInput === inputId;
        },
        handlePopState(event) {
            // console.log("handlePopState : ", event);
            const urlParams = new URLSearchParams(window.location.search);
            var urlSlug = urlParams.get('q');
            // console.log("urlSlug :", urlSlug);
            if (urlSlug) {
                const decodedSlug = atob(urlSlug);
                const urlData = JSON.parse(decodedSlug);
                this.eventName = urlData.e_name;
                this.eventId = urlData.e_id;
                this.bibNo = urlData.bibNo;
            } else {
                // console.log('came here');
                this.resetEventData();
                this.isResultLoading = true;
                this.leaderboardData = null;
            }

            if (this.eventName && this.eventId && !this.bibNo) {
                this.fetchEventLeaderboard(this.eventId);
                this.fetchRaces(this.eventId);
                return;
            } else if (this.eventName && this.eventId && this.bibNo) {
                this.fetchRaces(this.eventId);
                this.fetchBibDetails(this.eventId, this.bibNo);
                return;
            }
        },
        resetEventData() {
            this.eventName = null;
            this.eventId = null;
            this.events = [];
            this.eventType = null;
            this.eventPoweredByStatus = null;
            this.eventPoweredByLogo = null;
            this.resetRaceData();
        },
        resetRaceData() {
            this.races = [];
            this.raceId = null;
            this.resetBracketData();
        },
        resetBracketData() {
            this.brackets = [];
            this.bracketId = null;
            this.resetBibData();
        },
        resetBibData() {
            this.bibNo = null;
            this.bibType = null;
            this.bibData = null;
        },
        callApi(url, method, options, scroll = true) {
            if (this.confettiInterval) {
                clearInterval(this.confettiInterval);
                this.confettiInterval = null;
            }
            if (scroll) {
                window.scrollTo(0, 0);
            }

            const delay_time = (this.eventPoweredByStatus && this.eventPoweredByLogo) ? 2000 : 0;

            const delay = new Promise(resolve => setTimeout(resolve, delay_time));

            const request = axios({
                method: method,
                url: url,
                ...options
            });

            this.isIpBlocked = false;
            return Promise.all([request, delay]).then(([response]) => {
                // this.initializeReadMore();
                let decodedData = atob(response.data.data);
                let data = JSON.parse(decodedData);
                return data;
            }).catch(error => {
                if (error.status == 429 && error.response?.data?.ip_message) {
                    this.isIpBlocked = true;
                }
                window.scrollTo(0, 0);
                // console.error("API call error:", error);
                this.isResultLoading = false;
                this.display = 'something-went-wrong';
                return Promise.reject(error);
            });
        },
        initializeReadMore() {
            if ($(".read-more-btn").length) {
                $(".read-more-btn").off("click").on("click", function () {

                    const $btn = $(this);
                    const $text = $btn.prev(".textside");

                    $text.toggleClass("expanded");
                    $btn.toggleClass("expanded");

                    if ($text.hasClass("expanded")) {
                        $text.css("max-height", $text.prop("scrollHeight") + "px");
                        $btn.find(".btn-text").text("Show Less");

                        $btn.find(".read-more-icon").hide();
                        $btn.find(".read-less-icon").show();
                    } else {
                        $text.css("max-height", "66px");
                        $btn.find(".btn-text").text("Show More");

                        $btn.find(".read-more-icon").show();
                        $btn.find(".read-less-icon").hide();
                    }
                });
            }

            if ($(".read-more-btn-mobile").length) {
                $(".read-more-btn-mobile").off('click').on('click', function () {

                    var $btn = $(this);
                    var $text = $btn.closest('.r-sidebarracerule-mobile')
                        .find(".textside-mobile");

                    $text.toggleClass("expanded");

                    var $iconMore = $btn.find(".read-more-icon");
                    var $iconLess = $btn.find(".read-less-icon");
                    var $btnText = $btn.find(".btn-text");

                    if ($text.hasClass("expanded")) {
                        $text.css("max-height", $text.prop("scrollHeight") + "px");
                        $btnText.text("Show Less");
                        $iconMore.hide();
                        $iconLess.show();
                    } else {
                        $text.css("max-height", "0px");
                        $btnText.text("Show More");
                        $iconMore.show();
                        $iconLess.hide();
                    }
                });
            }

        },
        formatDate(dateString) {
            // console.log(dateString);
            if (dateString && dateString.includes(' ')) {
                const date = new Date(dateString);
                const options = {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                };
                return date.toLocaleDateString('en-US', options).toUpperCase();
            } else if (dateString) {
                // console.log("dateString : ", dateString);
                const [year, month, day] = dateString.split('-');
                const date = new Date(year, month - 1, day);
                const options = {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                };
                return date.toLocaleDateString('en-US', options).toUpperCase();
            } else {
                return '';
            }
        },
        formatTime(timeString) {
            if (timeString && timeString.includes('.')) {
                timeString = timeString.split('.')[0];
            }
            return timeString;
        },
        formatRunnerName(runnerName) {
            let names = runnerName.split(" ");
            let letter = '';
            let lastKey = names.length - 1;

            names.forEach((name, key) => {
                if (key === 0 || key === lastKey) {
                    letter += name.charAt(0);
                }
            });

            return letter;
        },
        calculateAvgSpeed(timeString) {
            if (timeString.includes('.')) {
                timeString = timeString.split('.')[0];
            }
            const [hours, minutes, seconds] = timeString.split(':').map(Number);
            const totalSeconds = (hours * 3600) + (minutes * 60) + seconds;
            const avgSpeed = 3600 / totalSeconds;
            const roundedAvgSpeed = Math.round(avgSpeed * 10) / 10;
            return roundedAvgSpeed.toFixed(1) + ' km/h';
        },
        scrollAccordion() {
            document.addEventListener('show.bs.collapse', function (event) {
                // Get all accordion elements
                const allAccordions = document.querySelectorAll('.accordion-collapse');

                // Loop through all accordion elements
                allAccordions.forEach((accordion) => {
                    // If the accordion is open and it's not the one being clicked
                    if (accordion !== event.target && accordion.classList
                        .contains('show')) {
                        // Hide the other open accordion
                        new bootstrap.Collapse(accordion, {
                            toggle: true // This will close the accordion
                        });
                    }
                });
            });

            document.addEventListener('shown.bs.collapse', function (event) {
                // console.log("event : ", event);

                // Get the accordion element that is being opened
                const accordionElement = event.target;
                // console.log("accordionElement : ", accordionElement);

                // Get the position of the accordion element
                const accordionTop = accordionElement.getBoundingClientRect().top + window
                    .scrollY;
                const header = document.querySelector('#navbarsticky');
                const headerHeight = header ? header.offsetHeight : 0;

                // Scroll to the calculated position with the given offset
                window.scrollTo({
                    top: accordionTop - headerHeight -
                        150, // Adjust the offset as needed
                    behavior: 'smooth'
                });
            });
        },
        triggerSwal(type, title = '', text = '') {
            Swal.fire({
                icon: type,
                title: title,
                text: text,
            });
        },
        triggerToast(type, text = '', pos = "top-right") {
            const arr = {
                'info': '#2196f3',
                'success': '#1abc9c',
                'error': '#e7515a'
            };
            Snackbar.show({
                text: text,
                pos: pos,
                actionTextColor: '#fff',
                backgroundColor: arr[type] || '#000'
            });
        },
        nextPage() {
            if (this.photosStartIndex + this.photosPerPage < this.bibData.photos.data.results.length) {
                this.photosStartIndex += this.photosPerPage;
            }
        },
        prevPage() {
            if (this.photosStartIndex - this.photosPerPage >= 0) {
                this.photosStartIndex -= this.photosPerPage;
            }
        },
        flagImageError(event) {
            this.participantFlag = false;
        },
        getAssetUrl(path) {
            return asserURL + '/' + path
        },
        getLiveResultLink(eventName, eventId) {
            const data = {
                e_name: eventName,
                e_id: eventId,
            };
            const encodedSlug = btoa(JSON.stringify(data));
            const liveResultLink = `${window.location.origin}/live-results?q=${encodedSlug}`;
            // console.log('Live Result Link:', liveResultLink);
            return liveResultLink;
        },
        handleEventInput: _.debounce(function () {
            this.triggerSearchEvent();
        }, 100),
        triggerSearchEvent() {
            if (!this.eventName || this.eventName.length < 3) {
                return 0;
            }
            this.searchEvent();
        },
        handleBibInput: _.debounce(function () {
            this.triggerSearchBib();
        }, 100),
        triggerSearchBib() {
            if (!this.eventId || !this.eventName || this.eventName.length < 3 || !this.bibNo || this.bibNo.length < 1) {
                return;
            }
            this.searchBib(this.eventId, this.bibNo);
        },
        updateYear() {
            this.resetEventData();
            this.isResultLoading = true;
            $("#eventNameInputPC").focus();
        },
        resultFormSubmit(e) {
            if (this.eventName && this.eventId && this.bibNo) {
                this.fetchRaces(this.eventId);
                this.fetchBibDetails(this.eventId, this.bibNo);
            }
        },
        searchEvent() {
            if (!this.eventName) {
                this.triggerToast('info', 'Please Enter Event Name')
                return 0;
            }
            if (this.autocompleteInitialized && $("#eventNameInputPC").autocomplete("instance")) {
                $("#eventNameInputPC").autocomplete("destroy");
            }
            const self = this;
            $("#eventNameInputPC").autocomplete({
                source: function (request, response) {
                    if (self.cachedEventsList && request.term && request.term === self.lastSearchedEvent) {
                        response(self.cachedEventsList);
                        return;
                    }

                    self.callApi('/frontend/api/event-search', 'get', {
                        params: {
                            name: request.term,
                            year: self.eventYear
                        }
                    }).then(data => {
                        // console.log("data : ", data);
                        self.cachedEventsList = data.events.length === 0 ? [{ label: "No Events Found", value: "" }] : data.events.map(event => ({
                            label: event.highlight ? event.highlight : event.name,
                            value: event.event_id,
                            plainText: event.name
                        }));
                        self.lastSearchedEvent = request.term;
                        response(self.cachedEventsList);
                        $(".ui-autocomplete").each(function () {
                            $(this).toggleClass("ac-scroll-enabled", self.cachedEventsList.length > 5);
                        });
                    });
                },
                minLength: 3,
                autoFocus: false,
                focus: function (event, ui) {
                    $("#eventNameInputPC").val(ui.item.plainText || ui.item.label);
                    return false;
                },
                open: function () {
                    var parentWidth = $('#event_year_div').outerWidth();
                    var parentTop = $('#event_year_div').offset().top - 25;
                    var parentLeft = $('#event_year_div').offset().left;
                    var parentHeight = $('#event_year_div').outerHeight();

                    $("ul.ui-menu").css({
                        'width': parentWidth + 'px',
                        'top': parentTop + parentHeight + 'px',
                        'left': parentLeft + 'px'
                    });
                },
                select: function (event, ui) {
                    self.eventId = ui.item.value;
                    self.eventName = ui.item.plainText;
                    if (!ui.item.value || ui.item.value == "No Events Found") {
                        return false;
                    }
                    const url = new URL(window.location.href);
                    const slug = btoa(JSON.stringify({
                        e_name: self.eventName,
                        e_id: self.eventId,
                    }));
                    url.searchParams.set('q', slug);
                    history.pushState(null, '', url.toString());
                    self.fetchRaces(self.eventId);
                    self.fetchEventLeaderboard(self.eventId);
                    self.isResultLoading = true;
                }
            });
            $("#eventNameInputPC").autocomplete("instance")._renderItem = function (ul, item) {
                return $("<li>")
                    .append($("<div>").html(item.label))
                    .appendTo(ul);
            };

            this.autocompleteInitialized = true;

            $("#eventNameInputPC").autocomplete("search", this.eventName);
        },
        searchBib(eventId, bibNo) {
            if (!eventId) {
                this.triggerToast('info', 'Please Enter Event Name')
                return;
            }
            if (!bibNo) {
                this.triggerToast('info', 'Please Enter Runner Name / BIB No.');
                return;
            }
            // if (!isNaN(bibNo)) {
            //     this.fetchBibDetails(eventId, bibNo);
            //     return;
            // }

            if (this.autocompleteInitialized && $("#bibInputPC").autocomplete("instance")) {
                $("#bibInputPC").autocomplete("destroy");
            }

            let condition = /^[A-Za-z\s]+$/.test(bibNo);
            if (condition && String(bibNo).trim().length < 3) {
                return 0;
            }

            const self = this;
            $("#bibInputPC").autocomplete({
                source: function (request, response) {
                    if (self.cachedParticipantList && self.bibNo === self.lastSearchedParticipant) {
                        response(self.cachedParticipantList);
                        return;
                    }

                    self.callApi('/frontend/api/event-bibs', 'get', {
                        params: {
                            event_id: self.eventId,
                            term: self.bibNo
                        }
                    }).then(data => {
                        self.cachedParticipantList = data.participants.length === 0
                            ? [{ label: "No Runners Found", value: null }]
                            : data.participants.map(p => ({
                                label: p.highlight ? `${p.highlight}  (${p.bibno})` : `${p.full_name}  (${p.bibno})`,
                                value: p.bibno,
                            }));
                        self.lastSearchedParticipant = self.bibNo;
                        response(self.cachedParticipantList);
                        $(".ui-autocomplete").each(function () {
                            $(this).toggleClass("ac-scroll-enabled", self.cachedParticipantList.length > 5);
                        });
                    });
                },
                minLength: 1,
                autoFocus: false,
                open: function () {
                    var parentWidth = $('#bib_input_div').outerWidth();
                    var parentTop = $('#bib_input_div').offset().top - 25;
                    var parentLeft = $('#bib_input_div').offset().left;
                    var parentHeight = $('#bib_input_div').outerHeight();

                    $("ul.ui-menu").css({
                        'width': parentWidth + 'px',
                        'top': parentTop + parentHeight + 'px',
                        'left': parentLeft + 'px'
                    });
                },
                select: function (event, ui) {
                    self.bibNo = ui.item.value;
                    if (!ui.item.value || ui.item.value == "No Runners Found") {
                        return false;
                    }
                    const url = new URL(window.location.href);
                    const slug = btoa(JSON.stringify({
                        e_name: self.eventName,
                        e_id: self.eventId,
                        bibNo: self.bibNo || null
                    }));
                    url.searchParams.set('q', slug);
                    history.pushState(null, '', url.toString());
                    self.fetchBibDetails(self.eventId, self.bibNo);
                }
            });

            $("#bibInputPC").autocomplete("instance")._renderItem = function (ul, item) {
                return $("<li>")
                    .append($("<div>").html(item.label))
                    .appendTo(ul);
            };

            this.autocompleteInitialized = true;

            $("#bibInputPC").autocomplete("search", this.bibNo);
        },
        fetchRaces(eventId) {
            this.callApi('/frontend/api/event-races', 'get', {
                params: {
                    event_id: eventId
                }
            }).then(data => {
                this.races = data?.races || [];
                this.brackets = [];
                this.$nextTick(() => {
                    this.scrollAccordion();
                });
            });
        },
        raceChanged(eventId, raceId) {
            this.resetBracketData();
            this.fetchBrackets(eventId, raceId);
            this.fetchRaceLeaderboard(eventId, raceId);
        },
        bracketChanged(eventId, raceId, bracketId) {
            this.fetchBracketLeaderboard(eventId, raceId, bracketId);
        },
        fetchBrackets(eventId, raceId) {
            if (!eventId || !raceId) {
                return;
            }
            this.eventId = eventId;
            this.raceId = raceId;
            this.callApi('/frontend/api/event-brackets', 'get', {
                params: {
                    event_id: eventId,
                    race_id: raceId
                }
            }).then(data => {
                this.brackets = data?.brackets || [];
            });
        },
        fetchEventLeaderboard(eventId) {
            this.resetRaceData();
            if (!eventId) {
                return;
            }
            this.isResultLoading = true;
            this.eventType = null;
            this.eventPoweredByStatus = null;
            this.eventPoweredByLogo = null;
            this.callApi('/frontend/api/event-leaderboard', 'get', {
                params: {
                    event_id: this.eventId,
                }
            }).then(data => {
                this.display = 'event_leaderboard';
                this.leaderboardData = data;
                this.eventYear = data.year;
                this.eventType = data.event?.type ?? null;
                this.eventPoweredByStatus = data.event?.powered_by_status ?? null;
                this.eventPoweredByLogo = data.event?.powered_by_logo ?? null;
                this.isResultLoading = false;
                gtag('event', 'leaderboard_viewed', {
                    'debug_mode': false,
                    event_category: 'Event',
                    event_id: this.eventId,
                    event_label: this.eventName,
                    page_section: 'Event Leaderboard'
                });
                this.$nextTick(() => {
                    this.initializeReadMore();
                });
            });
        },
        fetchRaceLeaderboard(eventId, raceId) {
            if (!eventId || !raceId) {
                this.triggerToast('info', 'Please Select Event')
                return 0;
            }
            this.isResultLoading = true;
            this.callApi('/frontend/api/race-leaderboard', 'get', {
                params: {
                    event_id: this.eventId,
                    race_id: this.raceId
                }
            }).then(data => {
                // console.log(data);
                this.isResultLoading = false;
                data.results = Object.values(data.results);
                if (data.results.length == 0) {
                    if (data.isRaceNonTimed) {
                        this.display = 'non-timed-error';
                        return;
                    }
                    this.display = 'error';
                    return;
                }
                this.display = 'race_leaderboard';
                this.leaderboardData = data;
                gtag('event', 'leaderboard_viewed', {
                    'debug_mode': false,
                    event_category: 'Event',
                    event_id: this.eventId,
                    event_label: this.eventName,
                    race_id: this.leaderboardData.race.race__id,
                    race_name: this.leaderboardData.race.race_name,
                    page_section: 'Race Leaderboard'
                });
                this.$nextTick(() => {
                    this.initializeReadMore();
                });
            });
        },
        fetchBracketLeaderboard(eventId, raceId, bracketId) {
            // console.log(eventId, raceId, bracketId);
            if (!eventId) {
                return;
            }
            this.isResultLoading = true;
            this.callApi('/frontend/api/bracket-leaderboard', 'get', {
                params: {
                    event_id: this.eventId,
                    race_id: this.raceId,
                    bracket_id: this.bracketId,
                }
            }).then(data => {
                // console.log("data: ", data);
                this.isResultLoading = false;
                if (data.results == 0) {
                    if (data.isRaceNonTimed) {
                        this.display = 'non-timed-error';
                        return;
                    }
                    this.display = 'error';
                    return;
                }
                this.display = 'bracket_leaderboard';
                this.leaderboardData = data;
                gtag('event', 'leaderboard_viewed', {
                    'debug_mode': false,
                    event_category: 'Event',
                    event_id: this.eventId,
                    event_label: this.eventName,
                    bracket_id: this.leaderboardData.bracket.bracket__id,
                    bracket_name: this.leaderboardData.bracket.bracket_name,
                    page_section: 'Bracket Leaderboard'
                });
                this.$nextTick(() => {
                    this.initializeReadMore();
                });
            });
        },
        fetchBibDetails(eventId, bibNo) {
            if (!eventId || !bibNo) {
                return;
            }
            this.eventPoweredByStatus = null;
            this.eventPoweredByLogo = null;
            this.isResultLoading = true;
            this.comparedBib = null;
            this.comparedData = null;
            this.isMJVideoPlayed = false;
            this.eventType = null;
            this.callApi('/frontend/api/event/bib/fetch', 'get', {
                params: {
                    event_id: eventId,
                    bibNo: bibNo,
                }
            }).then(data => {
                if (!data.bibNo) {
                    return;
                }
                this.eventType = data.event?.type ?? null;
                this.eventPoweredByStatus = data.event?.powered_by_status ?? null;
                this.eventPoweredByLogo = data.event?.powered_by_logo ?? null;
                this.showBib(eventId, data.bibNo, data.type);
            });
        },
        showBib(eventId, bibNo, type) {
            this.isResultLoading = true;
            if (this.autocompleteInitialized && $("#bibInputPC").autocomplete("instance")) {
                $("#bibInputPC").autocomplete("destroy");
                $("#bibInputPC").blur();
            }
            if (!eventId || !bibNo || !type || !['chronotrack', 'copernico', 'csv', 'relay'].includes(
                type)) {
                this.isResultLoading = false;
                this.display = 'error';
                return;
            }
            var url = null;
            if (type == 'chronotrack' || type == 'copernico') {
                url = '/frontend/api/event/bib/result';
            } else if (type == 'csv') {
                url = '/frontend/api/event/bib/non-timed-result';
            } else if (type == 'relay') {
                url = '/frontend/api/event/bib/relay-result';
            }
            this.callApi(url, 'get', {
                params: {
                    event_id: eventId,
                    bibNo: bibNo,
                }
            }).then(data => {
                const url = new URL(window.location.href);
                const slug = btoa(JSON.stringify({
                    e_name: this.eventName,
                    e_id: eventId,
                    bibNo: bibNo || null
                }));
                url.searchParams.set('q', slug);
                history.pushState(null, '', url.toString());
                if (type != 'csv' && (!data || !data.race)) {
                    this.display = 'something-went-wrong';
                    this.isResultLoading = false;
                    return;
                }
                this.display = 'bib';
                this.bibNo = bibNo;
                this.bibType = type;
                this.bibData = data;
                this.eventYear = data.year;
                this.isResultLoading = false;
                this.raceId = data.race?.race_id ?? null;
                this.fetchBrackets(eventId, this.raceId);
                // this.bracketId = null;
                // this.brackets = [];
                gtag('event', 'participant_viewed', {
                    'debug_mode': false,
                    event_label: this.bibData.event.name,
                    event_id: this.bibData.event.event_id,
                    participant_bibno: this.bibData.participant.bibno,
                    participant_full_name: this.bibData.participant.full_name,
                });
                this.$nextTick(() => {
                    this.initializeReadMore();
                    setTimeout(() => {
                        this.initializeSpy();
                    }, 1000);
                    if (data.brackets) {
                        this.checkForConfetti(data.brackets);
                    }
                    if (window.innerWidth < 992) {
                        window.scrollTo({
                            top: 5,
                            behavior: 'smooth'
                        })
                    }

                    Fancybox.bind("[data-fancybox='gallery']", {
                        caption: (fancybox, slide) => {
                            const imageApiType = slide.photoApi;
                            const imageType = slide.photoType;
                            let caption = ``;

                            // console.log(imageApiType, imageType);
                            if (imageApiType == 'ssp') {
                                const downloadUrl = slide.downloadUrl;
                                const redirectUrl = slide.redirectUrl;
                                if (imageType === 'free' && downloadUrl) {
                                    caption +=
                                        `<a href="${downloadUrl}" target="_blank" class="btn even-button w-100">Download Photo</a>`;
                                }
                                if (imageType === 'paid' && redirectUrl) {
                                    const spp = slide.spp;
                                    const app = slide.app;
                                    caption +=
                                        `<a href="${redirectUrl}" target="_blank" class="btn even-button w-100" style="max-width: max-content;">Buy Photo @ ${app} INR</a>`;
                                }
                            }

                            if (imageApiType == 'captured') {
                                const downloadUrl = slide.downloadUrl;
                                const redirectUrl = slide.redirectUrl;
                                if (imageType === 'free' && downloadUrl) {
                                    caption +=
                                        `<a href="${downloadUrl}" target="_blank" class="btn even-button w-100">Download Photo</a>`;
                                }
                                if (imageType === 'paid' && redirectUrl) {
                                    caption +=
                                        `<a href="${redirectUrl}" target="_blank" class="btn even-button w-100">Buy Photo</a>`;
                                }
                            }

                            return caption;
                        },
                    });
                });
            }).catch(error => {
                this.display = 'something-went-wrong';
                this.isResultLoading = false;
            });
        },
        submitComparison(eventId, bibNo, raceId) {
            this.isResultLoading = true;
            this.comparedData = null;
            this.callApi('/frontend/api/event/bib/comparison', 'get', {
                params: {
                    event_id: eventId,
                    race_id: raceId,
                    bib_no: bibNo,
                    compare_bib_no: this.comparedBib,
                }
            }, false).then(data => {
                this.isResultLoading = false;
                if (!data.status) {
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.initializeReadMore();
                            this.initializeSpy();
                        }, 1500);
                    });
                    this.triggerToast('info', data.message);
                    return;
                }
                this.comparedData = data.data;
                gtag('event', 'participant_comparison', {
                    'debug_mode': false,
                    event_label: this.bibData.event.name,
                    event_id: this.bibData.event.event_id,
                    participant_bibno: this.comparedData.bibParticipant.participant.bibno,
                    participant_full_name: this.comparedData.bibParticipant.participant.full_name,
                    compared_participant_bibno: this.comparedData.compareParticipant.participant.bibno,
                    compared_participant_full_name: this.comparedData.compareParticipant.participant.full_name,
                });
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.initializeReadMore();
                        this.initializeSpy();
                    }, 1500);
                });
            }).catch(error => {
                this.display = 'something-went-wrong';
                this.isResultLoading = false;
            });
        },
        handleCompareRunnerInput: _.debounce(function () {
            if (!this.eventId || !this.eventName || this.eventName.length < 3 || !this
                .comparedBib) {
                return 0;
            }
            this.searchRunnerNameForCompare(this.eventId, this.raceId, this.comparedBib);
        }, 1000),
        searchRunnerNameForCompare(eventId, raceId, term) {
            if (!eventId) {
                this.triggerToast('info', 'Event Name Missing')
                return 0;
            }
            if (!term) {
                this.triggerToast('info', 'Please Enter Runner Name / BIB No.');
                return 0;
            }
            // if (!isNaN(term)) {
            //     return 0;
            // }

            if (this.autocompleteInitialized && $("#bibInput_result").autocomplete("instance")) {
                $("#bibInput_result").autocomplete("destroy");
            }
            const self = this; // Store reference to Vue instance
            $("#bibInput_result").autocomplete({
                source: function (request, response) {
                    self.callApi('/frontend/api/event-bibs-for-comparison', 'get', {
                        params: {
                            event_id: self.eventId,
                            race_id: raceId,
                            bib_no: self.bibNo,
                            term: term
                        }
                    }, false).then(data => {
                        if (data.results.length === 0) {
                            response([{
                                label: "No Runners Found",
                                value: null
                            }]);
                        } else {
                            var participants = data.results.map(participant => ({
                                label: `${participant.full_name} - BIB - ${participant.bibno}`,
                                value: participant.bibno
                            }));
                            response(data.results.map(participant => ({
                                label: `${participant.full_name} - BIB - ${participant.bibno}`,
                                value: participant.bibno
                            })));
                        }
                    });
                },
                minLength: 3,
                autoFocus: false,
                open: function () {
                    var parentWidth = $('#bibInput_result').outerWidth();
                    var parentTop = $('#bibInput_result').offset().top - 25;
                    var parentLeft = $('#bibInput_result').offset().left;
                    var parentHeight = $('#bibInput_result').outerHeight();

                    $("ul.ui-menu").css({
                        'width': parentWidth + 'px',
                        'top': parentTop + parentHeight + 10 + 'px',
                        'left': parentLeft + 'px',
                        'max-height': '250px',
                        'overflow-y': 'scroll',
                        'overflow-x': 'hidden',
                        'scrollbar-width': 'thin'
                    });
                },
                select: function (event, ui) {
                    // console.log(ui);
                    self.comparedBib = ui.item.value;
                    if (!ui.item.value || ui.item.value == "No Runners Found") {
                        return false;
                    }
                    self.submitComparison(eventId, self.bibNo, raceId);
                }
            }).autocomplete("search", this.comparedBib);
            this.autocompleteInitialized = true;
        },
        getShareLink(type, eventName) {
            const currentUrl = window.location.href;
            let url = ''; // Initialize the url variable

            if (type === 'whatsapp') {
                const message =
                    `Check out My Timing Results at ${eventName}\n\n${currentUrl}\n\n- Timed by STS`;
                url = `whatsapp://send?text=${encodeURIComponent(message)}`;
            } else if (type === 'facebook') {
                url =
                    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;
            } else if (type === 'twitter') {
                const tweetText = `Check out My Timing Results at ${eventName}!`;
                url =
                    `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText + '\n\n' + currentUrl + '\n\n- Timed by STS')}`;
            }

            return url;

        },
        onMJVideoPlay(eventId, bibNo) {
            if (!this.isMJVideoPlayed) {
                this.callApi('/frontend/api/event/mj/viewed', 'post', {
                    params: {
                        event_id: eventId,
                        bib_no: bibNo,
                    }
                }, false).then(data => {
                    if (data.status) {
                        this.isMJVideoPlayed = true;
                    }
                }).catch(error => { });
            }

        },
        shareMJLink(type) {
            var eventId = this.eventId;
            var bibNo = this.bibNo;
            var mjLink = mjPageURL;
            const eventName = this.bibData.event.name;
            const currentPageUrl = `${mjLink}/show.php?bib_no=${bibNo}`;
            const message = `Check out #MyJourney at ${eventName}!`;

            let url = null;
            let social_name = null;
            if (type === 'wa') {
                social_name = 'WhatsApp';
                url = `https://wa.me/?text=${encodeURIComponent(`${message}\n${currentPageUrl}`)}`;
            } else if (type === 'fb') {
                social_name = 'Facebook';
                url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentPageUrl)}&quote=${encodeURIComponent(message)}`;
            } else if (type === 'tw') {
                social_name = 'Twitter';
                url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(`${message}\n${currentPageUrl}`)}`;
            }

            window.open(url, '_blank', 'noopener,noreferrer');

            this.callApi('/frontend/api/event/mj/share', 'post', {
                params: {
                    event_id: eventId,
                    bib_no: bibNo,
                }
            });

            gtag('event', 'participant_mj_share', {
                debug_mode: false,
                event_label: eventName,
                event_id: eventId,
                participant_bibno: this.bibData.participant.bibno,
                participant_full_name: this.bibData.participant.full_name,
                share_platform: social_name,
            });


        },
        downloadMJLink() {
            var eventId = this.eventId;
            var bibNo = this.bibNo;
            const downloadUrl = `/frontend/api/event/mj/download-file?event_id=${eventId}&bib_no=${bibNo}`;
            window.open(downloadUrl, '_blank');
        },
        copyLink() {
            let url = window.location.href;
            if (window.clipboardData && window.clipboardData.setData) {
                return window.clipboardData.setData("Text", url);

            } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
                var textarea = document.createElement("textarea");
                textarea.textContent = url;
                textarea.style.position = "fixed"; // Prevent scrolling to bottom of page.
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    this.triggerToast('success', "Link Copied");
                    return document.execCommand(
                        "copy"); // Security exception may be thrown by some browsers.

                } catch (ex) {
                    console.warn("Copy to clipboard failed.", ex);
                    return false;
                } finally {
                    document.body.removeChild(textarea);
                }
            }
        },
        initializeSpy() {
            new bootstrap.ScrollSpy(document.body, {
                target: '#list-example',
            });
            $('[data-bs-spy="scroll"]').each(function () {
                $(this).scrollspy('refresh');
            });
            let stickyinput;
            const section = document.getElementById("sticky-section");
            const fakeHeightDiv = document.querySelector(".nav-fake-height");
            const formContainer = document.getElementById("form-container");


            if (section) {
                stickyinput = section.offsetTop;
            }
            window.addEventListener("scroll", function () {
                if (section) {
                    if (window.pageYOffset + 120 >= stickyinput) {
                        section.classList.add("sticky-sectionnew");
                        if (fakeHeightDiv) {
                            fakeHeightDiv.classList.add("mysts-height");
                        }
                        if (formContainer) {
                            formContainer.classList.add("my-sts-form");
                        }
                    } else {
                        section.classList.remove("sticky-sectionnew");
                        if (fakeHeightDiv) {
                            fakeHeightDiv.classList.remove("mysts-height");
                        }
                        if (formContainer) {
                            formContainer.classList.remove("my-sts-form");
                        }
                    }
                }
            });
        },
        checkForConfetti(brackets) {
            return true;
            if (brackets.length) {
                for (let i = 0; i < brackets.length; i++) {
                    if (brackets[i].bracket_rank == 1) {
                        const defaults = {
                            spread: 360,
                            ticks: 50,
                            gravity: 0.5,
                            decay: 0.94,
                            startVelocity: 30,
                            shapes: ["star"],
                            colors: ["FFE400", "FFBD00", "E89400", "FFCA6C",
                                "FDFFB8"
                            ],
                        };

                        const launchConfetti = () => {
                            confetti({
                                ...defaults,
                                particleCount: 40,
                                scalar: 1.2,
                                shapes: ["star"],
                                origin: {
                                    y: 0.6
                                },
                                element: document.querySelector(
                                    "#details")
                            });

                            confetti({
                                ...defaults,
                                particleCount: 10,
                                scalar: 0.75,
                                shapes: ["circle"],
                                origin: {
                                    y: 0.6
                                },
                                element: document.querySelector(
                                    "#details")
                            });
                        };

                        this.confettiInterval = setInterval(launchConfetti, 500);
                        setTimeout(() => {
                            clearInterval(this.confettiInterval);
                        }, 1500);
                        break;
                    }
                }
            }
        },
        downloadBibCard(eventName, bib) {
            const element = document.querySelector('.dwmain');
            const self = this;
            if (element) {
                html2canvas(element, {
                    scale: 1,
                    useCORS: true,
                    allowTaint: true,
                    backgroundColor: null,
                    width: 600,
                }).then(canvas => {
                    const link = document.createElement('a');
                    link.href = canvas.toDataURL('image/png');
                    const prefix = eventName.split(' ')[0]
                        .toLowerCase(); // Get the first word and convert to lowercase

                    const filename = `${prefix}-${bib}-sts.png`;
                    link.download = filename;
                    link.click();
                    self.updateParticipantStats('bib_card_downloaded');
                    gtag('event', 'participant_download', {
                        'debug_mode': false,
                        event_id: this.bibData.event.event_id,
                        event_label: this.bibData.event.name,
                        participant_bibno: this.bibData.participant.bibno,
                        participant_full_name: this.bibData.participant.full_name,
                        download_type: 'BIB Card',
                    });
                });
            }
        },
        updateParticipantStats(type, social_name = false) {
            this.callApi('/frontend/api/event/update-participant-stats', 'post', {
                params: {
                    event_id: this.eventId,
                    bib_no: this.bibNo,
                    stat_type: type
                }
            }, false).then(data => {
                if (social_name) {
                    gtag('event', 'participant_page_shared', {
                        'debug_mode': false,
                        event_id: this.bibData.event.event_id,
                        event_label: this.bibData.event.name,
                        participant_bibno: this.bibData.participant.bibno,
                        participant_full_name: this.bibData.participant.full_name,
                        share_platform: social_name,
                    });
                }
            }).catch(error => { });
        },
        submitCertificateForm(statType) {
            const certificateForm = document.getElementById('CertificateForm');
            if (certificateForm) {
                certificateForm.submit();
                this.updateParticipantStats(statType);
                gtag('event', 'participant_download', {
                    'debug_mode': false,
                    event_id: this.bibData.event.event_id,
                    event_label: this.bibData.event.name,
                    participant_bibno: this.bibData.participant.bibno,
                    participant_full_name: this.bibData.participant.full_name,
                    download_type: 'Certificate',
                });
            }
        },
        async submitSuggestionForm() {
            // console.log(this);return 0;
            this.suggestionFormErrors = {};
            this.suggestionFormLoading = true;
            try {
                const captchaToken = await this.getRecaptchaToken();
                let response = await axios.post('/frontend/api/event/suggestion/submit', {
                    event_id: this.eventId,
                    bib_no: this.bibNo,
                    name: this.suggestionForm_name,
                    email: this.suggestionForm_email,
                    mobile: this.suggestionForm_mobile,
                    service: this.suggestionForm_service,
                    experience: this.suggestionForm_experience,
                    suggestion: this.suggestionForm_suggestion,
                    'recaptcha_response': captchaToken
                });
                // console.log(response);
                this.suggestionFormLoading = false;
                if (response.data.status) {
                    this.triggerToast('success', "Form Submitted Successfully");
                    this.suggestionForm_name = '';
                    this.suggestionForm_email = '';
                    this.suggestionForm_mobile = '';
                    this.suggestionForm_service = '';
                    this.suggestionForm_experience = '';
                    this.suggestionForm_suggestion = '';
                    this.suggestionFormErrors = {};
                    setTimeout(() => {
                        let modalEl = document.getElementById("shareModal");
                        if (modalEl) {
                            let modal = bootstrap.Modal.getOrCreateInstance(modalEl);
                            modal.hide();
                        }
                    }, 2000);
                } else {
                    this.suggestionFormLoading = false;
                    this.triggerToast('error', response.data.message || "Something Went Wrong.");
                }

            } catch (error) {
                this.suggestionFormLoading = false;
                // console.log(error);

                if (error.response && error.response.status === 422) {
                    this.triggerToast('error', "Please check the form.");
                    this.suggestionFormErrors = error.response.data.errors;
                } else {
                    this.triggerToast('error', "Something Went Wrong.");
                }
            }

        },
        async getRecaptchaToken() {
            return new Promise((resolve) => {
                grecaptcha.ready(async () => {
                    const token = await grecaptcha.execute(googleCaptchaSiteKey, { action: "submit" });
                    resolve(token);
                });
            });
        },
        async initFingerprint() {
            try {
                const fp = await FingerprintJS.load();
                const r = await fp.get();
                // console.log("r.visitorId : ", r);
                const isHttps = window.location.protocol === "https:";
                document.cookie = `sts_fp=${r.visitorId}; path=/; max-age=315360000; ${isHttps ? 'Secure;' : ''} SameSite=Lax`;
            } catch (error) {
                // console.log("Err. ", error);
            }
        },
        handlePhotoSelect(event) {
            const file = event.target.files[0];
            if (!file) return;

            if (!file.type.startsWith('image/')) {
                this.triggerToast('error', 'Please select an image.');
                event.target.value = '';
                return;
            }
            if (file.size > 10 * 1024 * 1024) {
                this.triggerToast('error', 'Image size must not exceed 10 MB');
                event.target.value = '';
                return;
            }

            if (this.photoPreviewUrl) {
                URL.revokeObjectURL(this.photoPreviewUrl);
            }
            if (this.outputImageUrl) {
                URL.revokeObjectURL(this.outputImageUrl);
            }

            this.photoFile = file;
            this.photoPreviewUrl = URL.createObjectURL(file);

            this.showPhotoCrop = true;
            this.showPhotoOutput = false;

            this.$nextTick(() => {
                this.initializePhotoCrop();
            })

        },
        initializePhotoCrop() {
            const image = document.getElementById('photoCropImage');
            if (!image) return;

            if (this.photoCropper) {
                this.photoCropper.destroy();
                this.photoCropper = null;
            }

            this.photoCropper = new Cropper(image, {
                aspectRatio: 1.681,
                viewMode: 1,
                dragMode: 'move',
                autoCropArea: 0.8,
                responsive: true,
                background: false,
                guides: false,
                center: true,
                movable: true,
                zoomable: true,
                scalable: false,
                rotatable: false,
            });
        },
        async cropPhoto() {
            if (!this.photoCropper) {
                return;
            }

            const canvas = this.photoCropper.getCroppedCanvas({
                imageSmoothingEnabled: true,
                imageSmoothingQuality: 'high'
            });

            canvas.toBlob(async (blob) => {
                if (!blob) {
                    this.triggerToast('error', 'Unable to crop image.');
                    return;
                }

                this.croppedPhotoFile = new File(
                    [blob],
                    'photo.jpg',
                    {
                        type: 'image/jpeg'
                    }
                );

                if (this.photoPreviewUrl) {
                    URL.revokeObjectURL(this.photoPreviewUrl);
                }
                this.photoPreviewUrl = URL.createObjectURL(blob);

                this.destroyPhotoCrop();
                this.isPhotoSubmitting = true;

                try {
                    let runner_name;
                    const formData = new FormData();
                    if (this.bibData.participant.type == 'csv' || this.bibData.participant.type == 'relay') {
                        runner_name = this.bibData.participant.full_name;
                        if (this.bibData.participant.type == 'relay' && this.bibData.team) {
                            formData.append('chip_time', this.bibData.team.team_time);
                        }
                    } else {
                        runner_name = this.bibData.runnerShortName;
                        if (this.bibData.finished_time) {
                            formData.append('chip_time', this.bibData.finished_time);
                        }
                        if (this.bibData.gun_time) {
                            formData.append('gun_time', this.bibData.gun_time);
                        }
                    }

                    formData.append('image', this.croppedPhotoFile);
                    formData.append('event_id', this.eventId);
                    formData.append('name', runner_name);
                    formData.append('bib_no', this.bibNo);
                    formData.append('race_name', this.bibData.race.name);
                    formData.append('race_date', this.bibData.race.race_date);
                    formData.append('hash', this.bibData.raceSelfieHash);
                    formData.append('bib_type', this.bibData.participant.type);

                    const raceSelfieProcessingUrl = `${window.location.origin}/race-selfie/submit`;
                    const response = await axios.post(raceSelfieProcessingUrl, formData,
                        {
                            responseType: 'blob'
                        }
                    );
                    const imageBlob = response.data;

                    if (this.outputImageUrl) {
                        URL.revokeObjectURL(
                            this.outputImageUrl
                        );
                    }

                    this.outputImageUrl =
                        URL.createObjectURL(imageBlob);

                    this.showPhotoCrop = false;
                    this.showPhotoOutput = true;

                    // this.updateParticipantStats('race_selfie_generated');

                } catch (error) {
                    console.error('Race Selfie API error:', error);
                    this.triggerToast('error', 'Unable to generate Race Selfie.');
                    this.showPhotoCrop = true;
                    this.$nextTick(() => {
                        this.initializePhotoCrop();
                    });
                } finally {
                    this.isPhotoSubmitting = false;
                }
            }, 'image/jpeg', 0.9);
        },
        flipPhoto() {
            if (!this.photoPreviewUrl || this.isPhotoSubmitting || this.isFlipping) return;
            this.isFlipping = true;

            const oldUrl = this.photoPreviewUrl;
            const img = new Image();

            img.onload = () => {
                try {
                    // Badi photo ko chhota karo (iOS canvas limit + final output chhota hai)
                    const MAX = 2000;
                    const scale = Math.min(1, MAX / Math.max(img.naturalWidth, img.naturalHeight));
                    const w = Math.round(img.naturalWidth * scale);
                    const h = Math.round(img.naturalHeight * scale);

                    const canvas = document.createElement('canvas');
                    canvas.width = w;
                    canvas.height = h;

                    const ctx = canvas.getContext('2d');
                    ctx.translate(w, 0);
                    ctx.scale(-1, 1);
                    ctx.drawImage(img, 0, 0, w, h);

                    canvas.toBlob((blob) => {
                        this.isFlipping = false;
                        if (!blob) {
                            this.triggerToast('error', 'Unable to flip image.');
                            return;
                        }
                        this.destroyPhotoCrop();
                        this.photoPreviewUrl = URL.createObjectURL(blob);
                        URL.revokeObjectURL(oldUrl);
                        this.$nextTick(() => this.initializePhotoCrop());
                    }, 'image/jpeg', 0.92);
                } catch (e) {
                    this.isFlipping = false;
                    console.error('Flip failed:', e);
                    this.triggerToast('error', 'Unable to flip image.');
                }
            };

            img.onerror = () => {
                this.isFlipping = false;
                this.triggerToast('error', 'Unable to flip image.');
            };

            img.src = oldUrl;
        },
        destroyPhotoCrop() {
            if (this.photoCropper) {
                this.photoCropper.destroy();
                this.photoCropper = null;
            }
        },
        cancelPhotoCrop() {
            if (this.isPhotoSubmitting) return;

            this.destroyPhotoCrop();

            if (this.photoPreviewUrl) {
                URL.revokeObjectURL(this.photoPreviewUrl);
            }

            this.photoFile = null;
            this.photoPreviewUrl = null;
            this.croppedPhotoFile = null;
            this.outputImageUrl = null;

            this.showPhotoCrop = false;
            this.showPhotoOutput = false;
            this.isPhotoSubmitting = false;

            const input = document.getElementById('photoInput');
            if (input) {
                input.value = "";
            }
        },
        retakePhoto() {
            if (this.isPhotoSubmitting) return;
            this.destroyPhotoCrop();
            if (this.photoPreviewUrl) {
                URL.revokeObjectURL(this.photoPreviewUrl);
            }
            if (this.outputImageUrl) {
                URL.revokeObjectURL(this.outputImageUrl);
            }

            this.photoFile = null;
            this.photoPreviewUrl = null;
            this.croppedPhotoFile = null;
            this.outputImageUrl = null;

            this.showPhotoCrop = false;
            this.showPhotoOutput = false;
            this.isPhotoSubmitting = false;

            const input = document.getElementById('photoInput');
            if (input) {
                input.value = '';
            }
        },
        downloadRaceSelfie() {
            if (!this.outputImageUrl) {
                return;
            }

            const link = document.createElement('a');
            link.href = this.outputImageUrl;
            link.download = 'race-selfie-' + this.bibNo + '.png';

            document.body.appendChild(link);
            link.click();
            link.remove();

            this.updateParticipantStats('race_selfie_downloaded');
        },
        async sharePhoto() {
            if (!this.outputImageUrl) return;

            try {
                const response = await fetch(this.outputImageUrl);
                const blob = await response.blob();
                const file = new File(
                    [blob],
                    'race-selfie.png',
                    {
                        type: 'image/png'
                    }
                );

                if (navigator.share && navigator.canShare &&
                    navigator.canShare({
                        files: [file]
                    })
                ) {
                    await navigator.share({
                        title: 'My Race Selfie',
                        text: 'My Race Selfie',
                        files: [file]
                    });
                    this.updateParticipantStats('race_selfie_shared');
                    return;
                }

                if (navigator.share) {
                    await navigator.share({
                        title: 'My Race Selfie',
                        text: 'My Race Selfie',
                        url: this.outputImageUrl
                    });
                    this.updateParticipantStats('race_selfie_shared');
                    return;
                }

                this.triggerToast('info', 'Sharing is not supported on this device.');
            } catch (error) {
                if (error.name !== 'AbortError') {
                    console.error(
                        'Share error:',
                        error
                    );
                    this.triggerToast('info', 'Something went wrong.');
                }
            }
        },
        resetRaceSelfie() {
            if (this.photoCropper) {
                this.photoCropper.destroy();
                this.photoCropper = null;
            }

            if (this.photoPreviewUrl) {
                URL.revokeObjectURL(this.photoPreviewUrl);
            }

            if (this.outputImageUrl) {
                URL.revokeObjectURL(this.outputImageUrl);
            }

            this.photoFile = null;
            this.photoPreviewUrl = null;
            this.showPhotoCrop = false;
            this.showPhotoOutput = false;
            this.croppedPhotoFile = null;
            this.outputImageUrl = null;
            this.isPhotoSubmitting = false;

            const input = document.getElementById('photoInput');
            if (input) {
                input.value = '';
            }
        },
    },
    watch: {
        bibNo(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.resetRaceSelfie();
            }
        },
    },
}).mount('#app')

function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
}

function hideText() {
    let searchLoadDivElement = document.getElementById("searchLoadDiv");
    searchLoadDivElement.classList.add("searchLoadDivCompleted");

    // Hide the element after animation
    gsap.to(searchLoadDivElement, {
        duration: 1,
        opacity: 0,
        y: -searchLoadDivElement.offsetHeight,
        onComplete: function () {
            searchLoadDivElement.style.display = 'none';
        }
    });
    // document.querySelector('.dvab').style.display = 'block';
}

$(document).ready(function () {
    gsap.fromTo('.domElement', {
        opacity: 0,
        scale: 0.1,
        y: 0
    }, {
        duration: 1,
        opacity: 1,
        scale: 1,
        ease: "power4.out",
        onComplete: hideText,
        // onStart: function () {
        //     const images = document.querySelectorAll(".ptn-1");
        //     images.forEach(function (image) {
        //         image.style.opacity = 1;
        //     });
        // }
    });
});


